import translate from '../../translations'

export default data => {
  const str = `
    <div class="card card--edit-map" js-card-edit-map data-type="${data.type}">
      <input type="text" data-name="name" name="locations[${data.type}][${
  data.id
}][name]" class="card--edit-map__title" value="" placeholder="${translate(
  'NAME'
)}">
      <div class="flex justify-between mt-3">
        <div class="flex-grow">
          <input type="text" data-name="address" name="locations[${
  data.type
}][${data.id}][address]" value="" placeholder="${translate(
  'ADDRESS'
)}">
          <input type="text" data-name="country" name="locations[${
  data.type
}][${data.id}][country]" value="" placeholder="${translate(
  'COUNTRY'
)}" class="mt-2">
          <input type="text" data-name="phoneNumber" name="locations[${
  data.type
}][${data.id}][phoneNumber]" value="" placeholder="${translate(
  'PHONE'
)}" class="mt-2">
        </div>
        <div class="flex-grow">
          <div class="flex">
            <input type="text" data-name="postalCode" name="locations[${
  data.type
}][${data.id}][postalCode]" value="" placeholder="${translate(
  'ZIP_CODE'
)}" class="flex-grow">
            <input type="text" data-name="town" name="locations[${data.type}][${
  data.id
}][town]" value="" placeholder="${translate('CITY')}" class="flex-grow">
          </div>
          <input type="email" data-name="email" name="locations[${data.type}][${
  data.id
}][email]" value="" placeholder="${translate('EMAIL')}" class="mt-2">
          <input type="url" data-name="website" name="locations[${data.type}][${
  data.id
}][website]" value="" placeholder="${translate(
  'WEBSITE'
)}" class="mt-2" oninvalid="this.setCustomValidity('Veuillez renseigner une url complète commençant par http')">
          <input type="hidden" data-name="id" value="${data.id}">

        </div>
        <div class="flex-grow">
          <div class="link hidden" js-card-update>
                <svg class="icon icon--red" aria-hidden="true">
                    <use href="#icon-edit" xlink:href="#icon-edit"></use>
                </svg>
                <span>${translate('EDIT')}</span>                         
          </div>
          <div class="link create" js-card-confirm>
              <svg class="icon icon--green" aria-hidden="true">
                  <use href="#icon-check" xlink:href="#icon-check"></use>
              </svg>
              <span>${translate('VALIDATE')}</span>                    
          </div>

          <div class="link mt-2" js-card-delete>
            <svg class="icon icon--red" aria-hidden="true">
                <use href="#icon-close" xlink:href="#icon-close"></use>
            </svg>
            <span>${translate('DELETE')}</span>                        
          </div>
        </div>
      </div>
    </div>`

  return str
}
